<!-- presupuesto -->

@if(isActiveConfig){
    <h1 class="page-header"><i class="fas fa-cog"></i> Cuentas Sueldos <small> {{title}} - Fondo {{fundSelect}}</small> </h1>
    <div class="panel p-4">
        <app-setting-field-salary [employeeType]="employeeType" 
        [year]="filter.year"
        [version]="filter.version"
        [budgetEmployeeType]="budgetEmployeeType"
        [fundCode]="fundSelect"
        (activeChange)="changeSetting();isActiveConfig=$event"></app-setting-field-salary>
    </div>
} 



@if(activeSettingDepartament){
    <h1 class="page-header"><i class="fas fa-cog"></i> Departamentos Sueldos<small>   {{title}} - Fondo {{fundSelect}}</small> </h1>
    <app-setting-field-departament [departamentFilter]="411" [year]="filter.year" [version]="filter.version"
        [fundCode]="fundSelect"
        [employeeType]="employeeType"
            (activeChange)="changeSettingDepartament();activeSettingDepartament=$event;title='Configurar Departamento'"></app-setting-field-departament>
    }

 



@if(!isActiveConfig&& !activeSettingDepartament){
    
     <div class="row">
        <div class="col-12" [ngClass]="{'col-md-6': budgetFund?.length==1,'col-md-12': budgetFund?.length>1}">
            <h1 class="page-header "><i class="fa-hand-holding-usd fas"></i> Tabulación Sueldo </h1>
  
        </div>
        @if(budgetFund?.length>1){
            <div class="col-12  mb-3" [ngClass]="{'col-md-6': budgetFund?.length>1}">
       
            <div class="btn-group">           
            @for(f of budgetFund; track f.id){
            <button class="btn btn-white btn-sm" [ngStyle]="{'min-width': '120px'}" [class.active]="fundSelect ==f.fundCode" (click)="changeFund(f.fundCode)">Fondo {{f.fundCode}}</button>
            }
            </div>
          </div>
        }    
        <div class="col-12 col-md-6">
            <div class=" d-md-flex fw-bold align-items-center justify-content-end mt-3">
                <div class="">
                        <div class="dropdown-toggle">
                            <a href="javascript:;" data-bs-toggle="dropdown"
                                class="text-decoration-none text-dark text-opacity-75"><i
                                    class="fa fa-cog fa-fw me-1 text-dark text-opacity-50"></i> Opciones<b class="caret"></b></a>
    
                            <div class="dropdown-menu">
                                <a (click)="exportToExcel()" class="dropdown-item">Exportar Excel</a>
                                @if(!isBudgetDisabled){
                                <div role="separator" class="dropdown-divider"></div>
                                
                                @if(budgetVersionSelected?.entityGroup=='IASD'){
                                <a (click)="openModalSettingDepartament()" class="dropdown-item">Configurar Departamento</a>
                                }}
                                </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
    <app-budget-over-view [data]="items" [filterItemCode]="411" [departament]="selectedDepartament"></app-budget-over-view>
    <!--muestra las pestañas dependiendo del tipo de empleado si hay mas de un tipo de empleado-->
    @if(budgetEmployeeType?.length>1){
    <div class="row">
        <div class="col-12">
            <!-- begin panel -->
            <ul class="nav nav-tabs">
                @for(b of budgetEmployeeType; track b.id;let i = $index){
                <li class="nav-item">
                    <a [href]="'#'+b.employeeType" data-bs-toggle="tab" 
                    (click)="tabChange(b)" class="nav-link"
                    [class.active]="employeeType ==b.employeeType">{{b.employeeTypeName}}</a>
                </li>
                }
            </ul>
        </div>
        
    </div>
    }
    <div class="tab-content panel p-4 " [ngClass]="{ 'show active rounded-0 rounded-bottom': budgetEmployeeType?.length>1 }">
    
    
        <!--Crea las pestañas dependiendo del tipo de empleado-->
        @for(b of budgetEmployeeType; track b.id){
          <div class="tab-pane fade" [ngClass]="{ 'show active ': employeeType==b.employeeType }" id="{{b.employeeType}}">
                 
        
     @if(!isBudgetDisabled){
            @if(salaryEmployee[b.employeeType]?.length==0&&isLoading==false){
                <div class="alert alert-danger mt-2">
                    <strong>Advertencia!</strong> No se han configurado cuentas o departamentos.
                    <div class="d-flex gap-1 mt-2">
                      
                    <button class="btn btn-primary btn-sm" (click)="openModalSettingDepartament()">Configurar Departamento</button>
                    </div>
                </div>
            }
        }
        
            @if(salaryEmployee[b.employeeType]?.length > 0){
                <div class="row mb-3 mt-2 align-items-center">
                    <div class="col-6 col-md-5">
                        <ng-select  [items]="datalistEmployee[b.employeeType]" [hideSelected]="true"
                        [(ngModel)]="filterByEmployeeType[b.employeeType]" [multiple]="true"
                        bindLabel="codeName" bindValue="code" [closeOnSelect]="false" placeholder="Buscar diverso o nombre"
                        (change)="changeNgSelectFilter(b.employeeType)">
                    </ng-select>
                    </div>
                </div>
            <div class="table-data">
                <table class="table table-sm ">
                    <thead>
                        <tr>
                            <th class="sticky-column-1 text-nowrap ">Subcuenta</th>
                            <th class="sticky-column-2 text-nowrap  ">Nombre Empleado</th>
                            <th class="sticky-column-3" >Departamento</th>
                            @for(account of accountPlanVersion[b.employeeType]; track account.id){
                             <th  [ngStyle]="{'min-width': '160px'}" >                    
                                <div class="text-center ">
                                    <span>{{account.displayName}}&nbsp;@if(account.hint){
                        <i class="fas fa-question-circle" ngbTooltip="{{account.hint}}" placement="top"
                            [container]="'body'">
                        </i>
                        }</span>
                                    <br>
                                 @if(account.accountType!=2){
                                    <span >({{account.accountCode}})</span>
                                 }
                                </div> 
                            </th>
                            }
                            <th class="text-nowrap text-end">Totales</th>
                        </tr>
                    </thead>
                    <tbody>
                          <!--muestra una tabla cargando mientras se estan cargado los datos-->
                          @if(isLoading){
                            @for( i of rows ;track $index){
                            <tr  class="tr-custom">
                                @for( i of cols ;track $index){
                                <td> <p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                                }
                            </tr>
                            }
                        }
                        @for(employee of salaryEmployee[b.employeeType]; track employee.id){
                        <tr>
                            <td class="text-nowrap sticky-column-1 align-middle bg-light text-center">{{employee.employeeCode}}
                            </td>
                            <td class="text-nowrap sticky-column-2 align-middle bg-light">{{employee.names}}</td>
                            <td class="sticky-column-3" [ngClass]="{'custom-table-danger': !employee.departamentCode}">
                                @if(isBudgetDisabled){
                                    <span class="d-inline-block text-truncate py-1 px-2" [ngStyle]="{'min-width': '200px'}" [title]="getSelectedDepartament(employee)?.codeName || 'Sin departamento'">
                                        {{ getSelectedDepartament(employee)?.codeName || 'Sin departamento' }}
                                    </span>
                                }@else{
                                    <ng-select [ngClass]="{'custom-table-danger': !employee.departamentCode}"  [ngStyle]="{'min-width': '200px'}" [items]="dataDepartament" [hideSelected]="true"
                                        bindLabel="codeName" 
                                        [ngModel]="getSelectedDepartament(employee)"
                                        (change)="updateDepartamentEmployee(employee.id,$event)"
                                        [appendTo]="'body'"
                                        [clearable]="false" placeholder="Seleccione un departamento">
                                    </ng-select>
                                }
                            </td>
                            @for(account of accountPlanVersion[employeeType]; track account.id){
                            @if(!account.block){
                            <td class="align-middle text-nowrap text-center">
                                @if(!isBudgetDisabled){
                                <input class="form-control form-control text-end" 
                                [ngStyle]="{'min-width': '140px'}"
                                (blur)="unSelectedDepartamentCode()"
                                (click)="toggleInput(accountInput.value);selectAll($event,employee)" (focus)="toggleInput(accountInput.value)"
                                    #accountInput type="text"
                                    [value]="getAccountValue(employee, account.accountCode) | number: '1.0-0'"
                                    (change)="updateValueAccounts(employee, account.accountCode, accountInput.value,1)"                   
                                       appNumberFormat>
                                }@else{
                                    <span [ngStyle]="{'min-width': '250px'}">{{getAccountValue(employee, account.accountCode) | number: '1.0-0'}}</span>
                                }
                                
                            </td>
                            }@else {
                            <td class="align-middle text-nowrap text-end bg-light" [ngStyle]="{'min-width': '140px'}">
                                <span>{{getAccountValue(employee, account.accountCode) | number: '1.0-0'}}</span>
                            </td>
                            }
            
                        }
                            <td class="text-nowrap align-middle bg-light text-end" style="min-width: 120px;"> $ {{getTotalEmployee(employee) | number:'1.0-0'}}</td>
                        </tr>
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            <th class="sticky-column-1"></th>
                            <th class="sticky-column-2"></th>
                            <th class="sticky-column-3">Sub Totales</th>
                            @for(account of accountPlanVersion[b.employeeType]; track i;let i= $index){
                                <th class="align-middle text-nowrap text-end">
                                  <span>{{ getSubtotalValue(account.accountCode,b.employeeType)| number: '1.0-0'}}</span>
                                </th>        
                            }
                            <th class="align-middle text-nowrap text-end">{{getSubtotalValue('total',b.employeeType)| number: '1.0-0'}}</th>        
                        </tr>
                    </tfoot>
                </table>
            </div>
            }
        </div>
        }
    </div>
    }
   
    
 